import { render } from "./review_promotion_form.vue?vue&type=template&id=4d493e4a&scoped=true"
import script from "./review_promotion_form.vue?vue&type=script&lang=js"
export * from "./review_promotion_form.vue?vue&type=script&lang=js"

import "./review_promotion_form.vue?vue&type=style&index=0&id=4d493e4a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d493e4a"]])

export default __exports__